// source: design/src/pages/EAMPage.tsx (export 2026-04-24)
/* eslint-disable max-len */
import SI from '../si/si_zh';

export default {
  // Reuse shared SI common copy to keep sub-pages aligned with SI root updates.
  common: SI.common,
  heroImage: 'si/images/hero-eam.jpg',
  heroTitle: '企业资产管理 (EAM)',
  heroTagline: '全生命周期资产管理，最大化资产价值',
  intro: [
    'EAM（Enterprise Asset Management，企业资产管理）是专门针对企业物理资产全生命周期管理的信息系统，覆盖资产采购、安装、运行、维护、报废的全过程。',
    '与ERP资产模块相比，EAM更专注于资产的运维管理深度，提供预防性维护、工单管理、故障分析等专业功能，是制造、能源、交通等资产密集型行业的核心系统。',
    '飞狼帮助企业建立数字化资产管理体系，通过智能化维护策略降低设备故障率，延长资产使用寿命。',
  ],
  modules: [
    {
      icon: 'si/si-icons/clipboard-list.svg',
      title: '资产台账管理',
      desc: '建立完整的资产电子档案，涵盖资产基本信息、技术参数、位置状态、归属关系等核心数据。',
    },
    {
      icon: 'si/si-icons/shield-check.svg',
      title: '预防性维护',
      desc: '基于时间或使用量触发维护计划，自动生成维护任务，降低计划外停机率达30%-50%。',
    },
    {
      icon: 'si/si-icons/wrench.svg',
      title: '工单管理',
      desc: '从工单创建、派工、执行、验收到关闭的全流程数字化管理，支持移动端现场作业。',
    },
    {
      icon: 'si/si-icons/package.svg',
      title: '备品备件',
      desc: '备件需求预测、安全库存预警、采购计划自动生成，平衡备件成本与供应保障。',
    },
    {
      icon: 'si/si-icons/file-check.svg',
      title: '合规与审计',
      desc: '满足ISO 55000等资产管理标准，提供完整审计追踪与合规报告。',
    },
    {
      icon: 'si/si-icons/smartphone.svg',
      title: '移动点巡检',
      desc: '支持NFC/二维码扫码巡检，离线数据采集，异常实时上报，提升巡检效率40%以上。',
    },
    {
      icon: 'si/si-icons/search.svg',
      title: '故障分析',
      desc: 'RCA根因分析、故障模式统计、MTBF/MTTR指标追踪，持续优化维护策略。',
    },
    {
      icon: 'si/si-icons/bar-chart-3.svg',
      title: 'KPI与报表',
      desc: '资产可用率、维护成本、工单完成率等关键指标可视化仪表盘。',
    },
  ],
  scenarios: [
    {
      icon: 'si/si-icons/zap.svg',
      title: '电力能源',
      desc: '电力变电站与发电厂设备巡检管理，变压器、开关柜、输电线路的全生命周期维护，保障电网安全稳定运行。',
    },
    {
      icon: 'si/si-icons/flask-conical.svg',
      title: '石油化工',
      desc: '管道、储罐、反应釜等关键设备的腐蚀监测与预防性维护，满足安全生产要求，降低装置非计划停工风险。',
    },
    {
      icon: 'si/si-icons/train.svg',
      title: '轨道交通',
      desc: '列车车辆、轨道设施、信号系统的维护管理，保障运营安全与准点率，延长设备服役周期。',
    },
    {
      icon: 'si/si-icons/server.svg',
      title: '数据中心',
      desc: '服务器、UPS、空调等IT基础设施的资产管理与维护，保障业务连续性，优化TCO总体拥有成本。',
    },
  ],
  benefits: [
    {
      // source: design/src/pages/EAMPage.tsx (icon: TrendingDown, color: #3784E6, export 2026-04-24)
      icon: 'si/si-icons/trending-down-blue.svg',
      title: '降低维护成本18%',
      desc: '预防性维护减少紧急维修，备件优化降低库存成本',
    },
    {
      // source: design/src/pages/EAMPage.tsx (icon: Clock, color: #3784E6, export 2026-04-24)
      icon: 'si/si-icons/clock-blue.svg',
      title: '减少计划外停机35%',
      desc: '预测性维护提前发现潜在故障，保障生产连续性',
    },
    {
      // source: design/src/pages/EAMPage.tsx (icon: Gauge, color: #3784E6, export 2026-04-24)
      icon: 'si/si-icons/gauge-blue.svg',
      title: '延长资产使用寿命',
      desc: '科学维护策略使设备寿命平均延长15%-20%',
    },
    {
      // source: design/src/pages/EAMPage.tsx (icon: Award, color: #3784E6, export 2026-04-24)
      icon: 'si/si-icons/award-blue.svg',
      title: '提升合规效率',
      desc: '数字化审计追踪，合规检查时间缩短50%',
    },
  ],
};
